const MOVIE_API ='2a8518c6ae8d6c8a2d0b6f6d40bee70f'

export default MOVIE_API